import { FC, RefObject, useEffect, useRef, useState } from "react";
import { Column, Row } from "../../containers";
import { AlignItems, JustifyContent } from "../../containers/types";
import { Heading, Text } from "../../typography";
import { useThemeStore } from "../../../stores";
import { FileInputProps } from "./types";
import { IconAnimation } from "../../animation";
import { AttachmentIcon } from "../../../assets/icons";
import ProgressBar from "../../progress-bar";

const FileInput: FC<FileInputProps> = ({
  setValue,
  value,
  label,
  props,
  inputProps,
  className = "",
  style = {},
  color,
  background,
}) => {
  const theme = useThemeStore((s) => s.theme);
  const ref: RefObject<HTMLInputElement> = useRef<HTMLInputElement>(null);

  const handleClick = (): void => {
    if (!ref.current) return;
    ref.current.click();
  };

  const [filename, setFileName] = useState<string>("");

  useEffect(() => {
    if (value && value.length) {
      setFileName(value[0].name);
    } else {
      setFileName("");
    }
  }, [value]);

  return (
    <Column
      alignItems={AlignItems.Start}
      justifyContent={JustifyContent.Start}
      gap={5}
      className={className}
      style={{ width: "100%", ...style }}
      props={props}
    >
      <Heading color={color || theme.textOnOverlay} size={16}>
        {label}
      </Heading>
      <Row
        style={{
          borderRadius: 15,
          background: background || theme.background,
          width: "calc(100% - 10px)",
          height: 41,
          paddingRight: 10,
          cursor: "pointer",
        }}
        justifyContent={JustifyContent.Between}
        props={{ onClick: handleClick }}
      >
        <Text
          color={
            background === theme.background
              ? theme.textOnBg
              : theme.textOnOverlay
          }
          textStyles={{
            fontFamily: value && value.length ? "monospace" : "IranSansRegular",
            marginRight: 8,
          }}
        >
          {value && value.length ? value[0].name : "انتخاب کنید"}
        </Text>
        <IconAnimation
          Icon={AttachmentIcon}
          onHoverColor={theme.primary}
          className="cursor-pointer"
          width={24}
          height={24}
          style={{ marginLeft: 8 }}
        />
      </Row>
      <input
        onChange={(e) => setValue(e.target.files)}
        ref={ref}
        type="file"
        style={{ display: "none" }}
        {...inputProps}
      />

      <ProgressBar
        filename={filename}
        background={background || theme.background}
      />
    </Column>
  );
};

export default FileInput;
